import { render, staticRenderFns } from "./automobileOne.vue?vue&type=template&id=67ae8f4c&scoped=true"
import script from "./automobileOne.vue?vue&type=script&lang=js"
export * from "./automobileOne.vue?vue&type=script&lang=js"
import style0 from "./automobileOne.vue?vue&type=style&index=0&id=67ae8f4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae8f4c",
  null
  
)

export default component.exports